import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Job status helpers
export function getStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    new: 'New',
    assigned: 'Assigned',
    on_the_way: 'On the Way',
    processing: 'Processing',
    finished: 'Finished',
    completed: 'Completed',
    finish_tomorrow: 'Finish Tomorrow',
    under_100: '<$100',
    rescheduled: 'Rescheduled',
    canceled: 'Canceled'
  }
  return labels[status] || status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    new: 'bg-gray-100 text-gray-800',
    assigned: 'bg-blue-100 text-blue-800',
    on_the_way: 'bg-purple-100 text-purple-800',
    processing: 'bg-amber-100 text-amber-800',
    finished: 'bg-orange-100 text-orange-800',
    completed: 'bg-green-100 text-green-800',
    finish_tomorrow: 'bg-indigo-100 text-indigo-800',
    under_100: 'bg-teal-100 text-teal-800',
    rescheduled: 'bg-slate-100 text-slate-800',
    canceled: 'bg-red-100 text-red-800'
  }
  return colors[status] || 'bg-gray-100 text-gray-800'
}

// Job type helpers
export function getJobTypeLabel(jobType: string): string {
  const labels: Record<string, string> = {
    full: 'Full',
    fin_under_100: 'Fin <$100',
    peredelka: 'Peredelka',
    demo: 'Demo'
  }
  return labels[jobType] || jobType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}

export function getJobTypeColor(jobType: string): string {
  const colors: Record<string, string> = {
    full: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    fin_under_100: 'bg-sky-100 text-sky-800 border-sky-200',
    peredelka: 'bg-amber-100 text-amber-800 border-amber-200',
    demo: 'bg-violet-100 text-violet-800 border-violet-200'
  }
  return colors[jobType] || 'bg-gray-100 text-gray-800 border-gray-200'
}
